import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import SmartRender from "containers/SmartRender";
import {} from "ducks/actions";
import { makeSelectIsSimActivated, makeSelectSimType } from "ducks/selectors";

const SimActivationStatusPolling = Component =>
  function Comp(props) {
    // const POLLING_INTERVAL = 3000;

    // const dispatch = useDispatch();
    const activationSuccess = useSelector(makeSelectIsSimActivated());
    const simType = useSelector(makeSelectSimType());
    // const order = useSelector(makeSelectGuestOrder());
    // const orders = useSelector(makeSelectUserOrders());

    /**
     * Start polling for esim activation status
     * Polling interval is a constant
     */
    // const pollForSimActivationStatus = () => {
    //   setTimeout(() => {
    //     dispatch(fetchUserOrders({}));
    //   }, POLLING_INTERVAL);
    // };

    useEffect(() => {
      /**
       * Initial fetch order details call
       */
      console.log("simeType", simType);
      // dispatch(fetchUserOrders({}));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //   // if (order === null) return;
    //   // if (fetchOrdersError) return;
    //   const order_ref = get(order, "orderRef");
    //   const updated_order = find(orders, { order_ref });
    //   if (get(updated_order, "state") === SIM_ACTIVATION_STATUSES.SUCCESS) {
    //     gotoUrl(pathWithChannel(paths.SIM_ACTIVATION_SUCCESS), {}, {}, true);
    //   } else {
    //     /**
    //      * Polling for orders.
    //      * The polling is done on orders as we fetch all user orders from the api
    //      */
    //     pollForSimActivationStatus();
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [orders, order]);

    return (
      <Component
        {...props}
        simType={simType}
        simActivated={activationSuccess}
      />
    );
  };

export default SimActivationStatusPolling(SmartRender);
